import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';

import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Store } from '@ngrx/store';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../../betplacement/models';
import { BetslipResultActions } from '../../../actions';
import { IResultSucceededSlipSummaryViewModel } from '../../../models/result-succeeded-slip.model';
import { IBetslipResultState } from '../../../state';
import LinearResultBaseComponent from './linear-result-base.component';
import { DigitalResultSummaryService } from './linear-result-summary.service';

@Component({
    selector: 'bs-digital-linear-result-system',
    templateUrl: './linear-result-system.component.html',
    styleUrls: ['base-linear-result-model.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DigitalResultSummaryService],
    standalone: false,
})
export class LinearResultSystemComponent extends LinearResultBaseComponent implements OnInit {
    @Input() succeededSlip: ISucceededSlipResult;
    @Input() moduleName: string;

    betslipType = BetslipType.System;
    systemKey = '';
    summaryViewModel: IResultSucceededSlipSummaryViewModel;

    readonly picksCount: string;

    constructor(
        private resultSummaryService: DigitalResultSummaryService,
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: ILinearBetslipMessagesProviderService,
        public store: Store<IBetslipRootState>,
    ) {
        super(store);

        const messages = messagesProvider.getMessages();
        this.picksCount = messages.linear.PicksCount;
    }

    ngOnInit(): void {
        this.summaryViewModel = this.resultSummaryService.getSummaryViewModel(this.succeededSlip, this.betslipType);
    }

    get subtitle(): string {
        return interpolateDoubleBracesString(this.picksCount, {
            count: this.succeededSlip.picks.length,
        });
    }

    get betType(): string {
        return this.succeededSlip.systemKey!;
    }

    keepPlaced(resultState: IBetslipResultState): boolean {
        return resultState.keepPlacedBetsInLinearSystem[this.succeededSlip.systemKey!];
    }

    onKeepPlacedChanged(value: boolean): void {
        this.store.dispatch(
            BetslipResultActions.keepPlacedBetsInLinearSystem({ systemKey: this.succeededSlip.systemKey!, keepPlacedBetsInLinearSystem: value }),
        );
    }
}
